import { Autocomplete, TextField } from "@mui/material";

export default function Selector({
  value,
  setValue,
  options,
  label,
  ...props
}) {

  return (
    <Autocomplete
      {...props}
      freeSolo
      options={options}
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setValue(newInputValue);
      }}
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
}
